export default "__VITE_ASSET__f210db0b__"